module.exports = __webpack_public_path__ + "static/media/dice-3.e3df847b.png";